export const fr = {
  Global: {
    save: 'Sauvegarder',
    savingInProgress: 'Saving in progress FR',
    edit: 'Rédiger',
    amend: 'Amend FR',
    editProposal: 'Edit proposal FR',
    delete: 'Supprimer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    proceed: 'Procéder',
    assign: 'Assigner',
    submit: 'Soumettre',
    accepted: 'Accepté',
    denied: 'Refusé',
    deny: 'Refuser',
    done: 'Terminé / Fini',
    notDone: 'Pas fini',
    started: 'Commencé',
    notRelevant: 'Non pertinent',
    noInfo: 'Pas d\'information',
    addComment: 'Ajouter un commentaire',
    noComments: 'Sans commentaires',
    comment: 'Commentaire',
    start: 'Début',
    end: 'Fin',
    pending: 'En attente',
    approve: 'Approuver',
    approved: 'Approuvé',
    notApproved: 'Non approuvé',
    release: 'Lancer',
    released: 'Lancé',
    notReleased: 'Non lancé',
    reopen: 'Rouvrir',
    requestedBy: 'Demandé par',
    requestedAt: 'Demandé à',
    proposedDecision: 'Décision proposée',
    proposedCategory: 'Catégorie proposée',
    proposedSubcategory: 'Sous-catégorie proposée',
    search: 'Chercher',
    noResults: 'Aucun résultat',
    upload: 'Télécharger',
    uploading: 'Téléchargement',
    noFilesUploaded: 'Aucun fichier téléchargé',
    close: 'Fermer',
    back: 'De retour',
    next: 'Prochain',
    unknown: 'inconnue',
    from: 'de',
    to: 'à',
    logout: 'Se déconnecter',
    profile: 'Profil',
    group: 'Groupe',
    code: 'Code',
    confirmationDialogTitle: 'Confirmation nécessaire',
    confirmDeleteFileDialogContent: 'Êtes-vous sûr de vouloir supprimer ce fichier?',
    report: 'rapport',
    unsavedAnswers: 'Vous avez des réponses non enregistrées. En confirmant, vous perdrez toutes les données non enregistrées.',
    unsavedAnswersActionMode: 'Vous avez des réponses non enregistrées. Voulez-vous les enregistrer?',
    noOptions: 'Aucune option',
    actionMode: 'Mode d\'action',
    reason: 'Raison',
    optional: 'optionnel',
    choose: 'Choisir',
    serialNumberMissing: 'Numéro de série manquant',
    recipientEmails: 'Recipient Emails (one address per line) FR',
    DatePicker: { // Sélecteur de date
      cancelLabel: 'Annuler',
      okLabel: 'D\'accord',
      minDateMessage: 'La date ne doit pas être antérieure à la date minimale',
      maxDateMessage: 'La date ne doit pas être postérieure à la date maximale',
      invalidDateMessage: 'Format de date non valide',
    },
    Errors: { // les erreurs
      authErrorTitle: 'Erreur d\'authentification!',
      authErrorParagraph1: 'Vous n\'êtes pas autorisé à accéder à cette application.',
      authErrorParagraph2: 'Veuillez contacter votre administrateur.',
      authErrorParagraph3: 'Ou déconnectez-vous d\'Active Directory et réessayez.',
      pageNotFound: 'Page non trouvée',
      pageNotFoundParagraph1: 'On ne trouve pas cette page',
      back: 'Accueil',
      rotateDevice: 'Veuillez tourner votre appareil.',
    },
    Feedback: { // Feedback/commentaire
      error: 'Une erreur s\'est produite ... L\'action a échoué.',
      authentication: 'Authentification ... Veuillez patienter',
      success: 'Action terminée avec succès',
      limitReached: 'Limite de décision commerciale atteinte.',
      requestHasBeenSentToApprover: 'Request has been sent to approver.',
      noQuestions: 'Aucune question pour la famille de produits sélectionnée.',
      decisionNotSend: 'La décision n\'a pas été envoyée avec succès au SAP.',
      noLimitForCC: 'Vous n\'avez pas de limite commerciale définie pour ce Customer center..',
      jobCostDoesNotExist: 'Job Cost from SAP Job does not exist in PARS database. FR',
      materialNumberBrandDoesNotExist: 'La marque de numéro d\'article n\'existe pas.',
      jobIsLocked: 'Le travail est bloqué',
      noPicturesAreUploaded: 'Aucune photo n\'est téléchargée',
      rateIsProvided: 'Evaluation a été enregistrée avec succès',
      rateHasToBeDifferent: 'La décision d´évaluation doit être différente de l\'ancienne',
    },
    Status: { // Statut
      title: 'Statut',
      awaitingEquipment: 'En attente d\'équipement',
      equipmentReceivedWithDocumentation: 'Matériel reçu avec documentation',
      jobReleased: 'Travail lancé',
      productEvaluation: 'Produit évalué',
      strippedAndDecontaminated: 'Dépouillé et décontaminé',
      builtAndTested: 'Construit et testé',
      shipped: 'Expédié',
      technicalAndCommercialDecision: 'Décision technique et commerciale',
      finalReportReleased: 'Publication du rapport final',
      closed: 'Fermé',
      productInvestigation: 'Investigation du produit',
      customerHold: 'Customer hold',
      notStarted: 'Pas commencé',
    },
    Roles: { // Les rôles
      RECEIVING: 'Recevoir',
      SERVICE_ENGINEER: 'Technicien de maintenance',
      FAILURE_ANALYSIS_ENGINEER: 'Failure analysis engineer',
      SENIOR_FAILURE_ANALYSIS_ENGINEER: 'Senior failure analysis engineer',
      FAILURE_ANALYSIS_MANAGER: 'Failure analysis manager',
      SERVICE_TECHNOLOGY_CENTER_MANAGER: 'Service technology center manager',
      QUALITY_MANAGER: 'Quality manager',
      SERVICE_TECHNICAL_SUPPORT_TEAM: 'Service technical support team',
      PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM: 'Product company technical support team',
      DIVISION_OR_BUSINESS_AREA: 'Division ou domaine d\'activité',
      CUSTOMER_CENTER: 'Customer center',
      CUSTOMER: 'Client',
      CUSTOMER_CENTER_SERVICE_ENGINEER: 'Customer center service engineer',
      SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER: 'Senior customer center service engineer FR',
      SUPERADMIN: 'Superadmin',
      ZONE_LEADER: 'Chef de zone',
      QUESTION_ADMIN: 'Administrateur des questions',
      DISTRIBUTOR: 'Distributeur',
    },
    Permissions: { // Autorisations
      VIEW_JOB: 'Voir le travail',
      EDIT_JOB: 'Modifier le travail',
      IMPORT_JOB_FROM_SAP: 'Importer le travail du SAP',
      LEVEL_3_RELEASE_FOR_INVESTIGATION: 'Niveau 3 lancé pour investigation',
      LEVEL_4_RELEASE_FOR_INVESTIGATION: 'Niveau 4 lancé pour investigation',
      GENERATE_AND_DOWNLOAD_REPORT: 'Générer et télécharger le rapport',
      VIEW_LOG: 'Afficher le log',
      VIEW_CONVERSATION: 'Afficher la conversation',
      PARTICIPATE_IN_CONVERSATION: 'Participez à la conversation',
      TAG_INTEREST: 'Marquer intérêt',
      ADD_REMOVE_FROM_TEAM: 'Ajouter et supprimer de l\'équipe',
      CREATE_JOB: 'Créer un travail',
      DELETE_JOB: 'Supprimer le travail',
      REQUEST_DIFFERENT_REPORT_LEVEL: 'Demander un niveau de rapport différent',
      APPROVE_DIFFERENT_REPORT_LEVEL: 'Approuver un niveau de rapport différent',
      WARRANTY_DECISION: 'Décision de garantie',
      GOODWILL_DECISION: 'Décision de goodwill',
      LEVEL_1_REPORT_APPROVAL: 'Approbation du rapport de niveau 1',
      LEVEL_2_REPORT_APPROVAL: 'Approbation du rapport de niveau 2',
      LEVEL_3_REPORT_APPROVAL: 'Approbation du rapport de niveau 3',
      LEVEL_4_REPORT_APPROVAL: 'Approbation du rapport de niveau 4',
      LEVEL_1_REPORT_REOPEN: 'Level 1 report reopen FR',
      LEVEL_2_REPORT_REOPEN: 'Level 2 report reopen FR',
      LEVEL_3_REPORT_REOPEN: 'Level 3 report reopen FR',
      LEVEL_4_REPORT_REOPEN: 'Level 4 report reopen FR',
      REOPEN_REPORT: 'Rouvrir le rapport',
      REQUEST_FAILED_PARTS: 'Demander des pièces défectueuses',
      SHIP_FAILED_PARTS: 'Expédier les pièces défectueuses',
      PRINT_INPUT_SHEETS: 'Imprimer les feuilles d\'entrée',
      ADMINISTRATE_QUESTIONS: 'Administrer les questions',
      ADMINISTRATE_DATA: 'Administrer les données',
      DOWNLOAD_PICTURES: 'Télécharger des photos',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Request technical warranty decission FR',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amend approved technical decision FR',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amend approved commercial decision FR',
      ADD_INITIAL_WARRANTY_CODE: 'Add initial warranty code FR',
      RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY: 'Reclasser la catégorie de décision technique',
      APPROVE_REPORT_LEVEL_4_DOWNGRADE: 'Approve report level 4 downgrade FR',
    },
    Alerts: { // Alertes
      noAlerts: 'Aucune alerte',
      healthAndSafetyInformationMissing: 'Informations sur la santé et la sécurité manquantes',
      jobNotReleased: 'Travail non lancé',
      noRecentStatusChange: 'Aucun changement de statut récent',
      noServiceTechnicalSupportInvolvement: 'Aucune implication de support technique de service',
      noProductCompanyTechnicalSupportInvolvement: 'Aucune implication du support technique de l´entreprise de produits',
      noTechnicalWarrantyDecision: 'Aucune décision de garantie technique',
      noCommercialDecision: 'Pas de décision commerciale',
      reportNotApproved: 'Rapport non approuvé',
    },
    Actions: { // Actions
      ADD_JOB: 'Travail ajouté',
      IMPORT_JOB: 'Tâche importée de SAP',
      DELETE_JOB: 'Travail supprimé',
      VERIFY_JOB: 'Travail vérifié',
      SET_PRICE: 'Travail modifié - Prix',
      ADD_TEAM_MEMBER: 'Membre de l\'équipe ajouté',
      REMOVE_TEAM_MEMBER: 'Membre de l\'équipe supprimé',
      REQUEST_REPORT_LEVEL_CHANGE: 'Changement de niveau de rapport demandé',
      APPROVE_REPORT_LEVEL_CHANGE: 'Changement de niveau de rapport approuvé',
      DENY_REPORT_LEVEL_CHANGE: 'Changement de niveau de rapport refusé',
      REQUEST_REPORT_APPROVAL: 'Demande d\'approbation du rapport',
      APPROVE_REPORT_APPROVAL: 'Approbation du rapport approuvé',
      DENY_REPORT_APPROVAL: 'Approbation de rapport refusée',
      SET_WARRANTY_START_DATE: 'Travail modifié - Date de début de la garantie',
      SET_WARRANTY_END_DATE: 'Travail modifié - Date de fin de garantie',
      EQUIPMENT_SERIAL_NUMBER_EDITED: 'Travail modifié - Numéro de série de l\'équipement',
      MATERIAL_NUMBER_EDITED: 'Travail modifié - Numéro d\'article',
      WORKED_ON_JOB: 'Travail modifié - Formulaire de mise à jour',
      UPLOADED_FILE_ON_JOB: 'Travail modifié - Fichier enregistré',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Décision de garantie technique demandée',
      APPROVE_TECHNICAL_WARRANTY_DECISION: 'Décision de garantie technique approuvée',
      DENY_TECHNICAL_WARRANTY_DECISION: 'Décision de garantie technique refusée',
      REQUEST_COMMERCIAL_WARRANTY_DECISION: 'Requested commercial warranty decision',
      APPROVE_COMMERCIAL_WARRANTY_DECISION: 'Décision de garantie commerciale approuvée',
      NULLIFY_COMMERCIAL_WARRANTY_DECISION: 'Décision de garantie commerciale annulée',
      DENY_COMMERCIAL_WARRANTY_DECISION: 'Décision commerciale de garantie refusée',
      SEND_COMMENT: 'Commentaire ajouté',
      REOPEN_REPORT: 'Travail modifié - Réouvrir le rapport',
      AWAITING_EQUIPMENT_STATUS_SET: 'Statut modifié - Ensemble d\'équipement en attente',
      AWAITING_EQUIPMENT_STATUS_RESET: 'Statut modifié - Réinitialisation de l\'Equipement en attente',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_SET: 'Statut modifié - Équipement reçu avec la documentation complété',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_RESET: 'Statut modifié - Réinitialisation de l´Equipement reçu avec la documentation',
      JOB_RELEASED_STATUS_SET: 'Statut modifié - Travail lancé complété',
      JOB_RELEASED_STATUS_RESET: 'Statut modifié - Réinitialisation du lancement de travail',
      PRODUCT_EVALUATION_STATUS_SET: 'Statut modifié - Evaluation du produit complété',
      PRODUCT_EVALUATION_STATUS_RESET: 'Statut modifié - Réinitialisation de l\'évaluation du produit',
      PRODUCT_INVESTIGATION_STATUS_SET: 'Statut modifié - Investigation du produit complété',
      PRODUCT_INVESTIGATION_STATUS_RESET: 'Statut modifié - Réinitialisation de l´Investigation du produit',
      STRIPPED_AND_DECONTAMINATED_STATUS_SET: 'Statut modifié - Dépouillé et décontaminé complété',
      STRIPPED_AND_DECONTAMINATED_STATUS_RESET: 'Statut modifié - Réinitialisation de Dépuillé et décontaminé',
      BUILT_AND_TESTED_STATUS_SET: 'Statut modifié - Construit et testé complété',
      BUILT_AND_TESTED_STATUS_RESET: 'Statut modifié - Réinitialisation de Construit et testé',
      SHIPPED_STATUS_SET: 'Statut modifié - Expédition complétée',
      SHIPPED_STATUS_RESET: 'Statut modifié - Réinitialisation de l\'expédition',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_SET: 'Statut modifié - Décision technique et commerciale complétées',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_RESET: 'Statut modifié - Réinitialisation de la décision technique et commerciale',
      FINAL_REPORT_RELEASED_STATUS_SET: 'Statut modifié - Lancement de rapport final complété',
      FINAL_REPORT_RELEASED_STATUS_RESET: 'Statut modifié - Réinitialisation du lancement de rapport final',
      CLOSED_STATUS_SET: 'Statut modifié - Fermeture complété',
      CLOSED_STATUS_RESET: 'Statut modifié - Réinitialisation de fermeture',
      CUSTOMER_HOLD_STATUS_SET: 'Statut modifié - Customer hold complété',
      CUSTOMER_HOLD_STATUS_RESET: 'Edited status - Customer hold  - not done',
      REFACTOR_TECHNICAL_WARRANTY_DECISION: 'Statut modifié - Réinitialisation de Customer hold',
      GENERATE_ALERT: 'Alerte générée',
      INITIAL_WARRANTY_CODE_EDITED: 'Code de garantie initial modifié',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amended approved technical warranty decision FR',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amended approved commercial decision FR',
      DELETE_APPROVED_TECHNICAL_DECISION: 'Deleted aproved technical warranty decision FR',
      DELETE_APPROVED_COMMERCIAL_DECISION: 'Deleted approved commercial decision FR',
      CHOOSE_RELEASE_METHOD: 'Chose release method FR',
    },
    TechnicalWarranty: { // Garantie technique
      ACCEPTED: 'Accepté',
      DENIED: 'Refusé',
      AGREE: 'Accepter',
      DISAGREE: 'Désapprouver',
      MANUFACTURING: 'Fabrication',
      DESIGN: 'Modèle',
      VENDOR: 'Vendeur',
      PROCESS: 'Processus',
      INHOUSE_REPAIR: 'In-house repair',
      FIELD_SERVICE_REPAIR: 'Field service repair',
      NO_FAULT_FOUND: 'Aucun défaut trouvé',
      WARRANTY_EXPIRED: 'Garantie expirée',
      WARRANTY_EXPIRED_NO_FAULT_FOUND: 'Garantie expirée - Aucun défaut trouvé',
      WARRANTY_EXPIRED_CUSTOMER_FAULT: 'Garantie expirée - Faute du client',
      WARRANTY_EXPIRED_OTHER: 'Garantie expirée - Autre',
      WARRANTY_EXPIRED_COMPONENT_ISSUE: 'Garantie expirée - Problème de composant (faute Edwards)',
      CUSTOMER_FAULT: 'Faute du client',
      OTHER: 'Autre',
      AGREE_WITH_TECHNICAL_WARRANTY_LOG: 'Accepter la décision technique',
      DISAGREE_WITH_TECHNICAL_WARRANTY_LOG: 'Désapprouver la décision technique',
      SPARE_PART: 'Spare part (Service Division) FR',
    },
    CommercialWarranty: { // Garantie commerciale
      CONTRACTUAL_AGREEMENT: 'Accord contractuel',
      GOODWILL_ACCEPTED: 'Goodwill accepté',
      CHARGEABLE_TO_CUSTOMER: 'À la charge du client',
      EXTENDED_WARRANTY: 'Garantie prolongée',
      SERVICE_CONTRACT: 'Service contract',
      OTHER: 'Autre',
      SEMICONDUCTOR: 'Semi-conducteur',
      SCIENTIFIC: 'Scientifique',
      INDUSTRIAL: 'Industriel',
      SEMICONDUCTOR_SERVICE: 'Semiconductor Service',
      VACUUM_TECHNIQUE_SERVICE: 'Vacuum Technique Service',
      SEMICONDUCTOR_CHAMBER_SOLUTIONS: 'Semiconductor Chamber Solutions',
      SEMI_ABATEMENT_AND_INTEGRATED_SYSTEMS: 'Semi Abatement & integrated systems',
      SEMI_ADVANCED_CHEMICAL_MANAGEMENT: 'Semi Advanced Chemical Management',
      SERVICE_CRYOGENICS: 'Service Cryogenics',
      SEMI_DRY_PUMPS: 'Semi Dry Pumps',
      INDUSTRIAL_CUSTOM_DESIGN: 'Industrial custom design',
      INDUSTRIAL_VACUUM: 'Industrial Vacuum',
      SCIENTIFIC_CUSTOM_DESIGN: 'Scientific custom design',
      SEMICON_TURBO_PUMPS: 'Semicon Turbo pumps',
      POLYCOLD: 'Polycold',
    },
    Release: { // Lancer
      NO_TECHNICAL_TEAM_INVOLVEMENT: 'Aucune implication de l\'équipe technique',
      GOLDENEYE_UPLINK: 'GoldenEye uplink',
      ON_SITE_PRESENCE: 'Présence sur site',
      RETURN_TO_PRODUCT_COMPANY: 'Retour à Product company',
      SEND_BACK_PARTS: 'Renvoyer des pièces',
    },
    Forms: { // Formes
      fields: {
        basicInformation: 'Informations de base',
        customerCenter: 'Customer center',
        serviceTechnologyCenter: 'Service technology center',
        reportLevel: 'Niveau de rapport',
        initialWarrantyCode: 'Garantie initiale code',
        technicalDecision: 'Décision technique',
        commercialDecision: 'Décision commerciale',
        price: 'Prix',
        jobStatus: 'Statut de l\'emploi',
        reportCompletion: 'Rapport d\'achèvement',
        alerts: 'Alertes',
        team: 'Équipe',
        customer: 'Client',
        customerContact: 'Contact client',
        jobDetails: 'Détails du travail',
        jobType: 'Type de travail',
        serviceProduct: 'Produit de service',
        equipment: 'Équipement',
        failure: 'Échec',
        symptom: 'Symptôme',
        address: 'Adresse',
        contactPerson: 'Contact',
        email: 'Email',
        phone: 'Téléphone',
        customerPurchaseOrderNumber: 'Numéro de bon de commande du client',
        equipmentWarranty: 'Garantie de l\'équipement',
        serviceWarranty: 'Garantie de service',
        reportStatus: 'État du rapport',
        reopen: 'Rouvrir',
        releaseJob: 'Lancer le travail',
        notifyTeam: 'Notify team FR',
      },
      errors: {
        required: 'Champ requis',
        tel: 'Veuillez entrer un numéro de téléphone valide.',
        email: 'Veuillez saisir un e-mail valide.',
        number: 'Seuls les nombres sont autorisés',
        alphanumeric: 'Aucun caractère spécial autorisé',
        text: 'Veuillez entrer une valeur valide',
        unknown: 'Il y a eu un problème...',
        belowZero: 'La valeur ne peut pas être inférieure à 0.',
        uploadFailed: 'Échec du téléchargement',
        maxFileSize: 'La taille maximale autorisée est',
        maxLength: maxLength => `Max ${maxLength} characters allowed FR`,
        minLength: minLength => `Please enter at least ${minLength} characters FR`,
      },
    },
    FaultCodes: { // Codes d'erreur
      fallbackDescription: 'Aucune description pour ce code',
      jobTypeDescription: { // Description du type
        'JT001': 'Description du type de travail JT001',
        'JT002': 'Description du type de travail JT002',
      },
      faultCodeDescription: { // Description du code
        'FC001': 'Description du code d\'erreur FC001',
        'FC002': 'Description du code d\'erreur FC002',
      },
      symptomCodeDescription: {
        'SC001': 'Description du code de symptôme SC001',
        'SC002': 'Description du code de symptôme FC002',
      },
    },
    Progress: { // Le progrès
      title: 'Le progrès',
      productReceived: 'Produit reçu',
      productEvaluation: 'Évaluation du produit',
      stripObservation: 'Strip observation',
      technicalInvestigation: 'Investigation technique',
      conformityTest: 'Test de conformité',
    },
  },
  Profile: { // Profil
    title: 'Profil',
    name: 'Nom',
    role: 'Rôle',
    company: 'Société',
    rights: 'Droits',
    linked: 'L\'utilisateur est lié à',
  },
  Jobs: { // Travaux
    title: 'Travaux',
    filters: 'Filtres',
    myJobs: 'Mes travaux',
    otherJobs: 'Autres travaux',
    noJobsToDisplay: 'Aucun travail à afficher.',
    pleaseUseTheSearchBar: "Please use the search bar. FR",
    id: 'Id',
    createdAt: 'Créé à',
    status: 'Statut',
    customer: 'Client',
    serialProductNumber: 'Numéro du produit de service',
    materialNumber: 'Numéro de matériel',
    equipmentSerialNumber: 'Numéro de série de l´équipement',
    customerCenterPlantCode: 'Customer center plant code',
    serviceTechnologyCenterPlannerGroup: 'S.t.c. groupe de planificateurs',
    handledBy: 'Traité par',
    reportLevel: 'Niveau de rapport',
    materialDescription: 'Description du matériel',
    customerName: 'Nom du client',
    receivedDate: 'Date de réception',
    customerCenterName: 'Nom CC',
    serviceOrderNumber: 'Numéro de commande de service',
    workFlow: 'Flux de travail',
    analysisFlow: 'Flux d\'analyse',
    productReceived: 'Produit reçu',
    productEvaluation: 'Évaluation du produit',
    stripObservation: 'Strip observation',
    technicalInvestigation: 'Investigation technique',
    conformityTest: 'Test de conformité',
    notificationNumber: 'Numéro de notification',
  },
  Job: { // Emploi
    editButton: 'Modifier',
    progress: 'Le progrès',
  },
  Filters: { // Filtres
    filtersTitle: 'Filtres',
    applyButton: 'Appliquer',
    clearButton: 'Clair',
    sorting: 'Tri',
    sortNew: 'Trier le plus récent',
    sortOld: 'Trier le plus ancien',
    date: 'Date',
    dateFrom: 'De',
    dateTo: 'À',
    reportLevel: 'Niveau de rapport',
    status: 'Statut',
    customerNumber: 'Numéro de client',
    customerName: 'Nom du client',
    serviceProductNumber: 'Numéro de produit de service',
    materialNumber: 'Numéro d\'article',
    equipmentSerialNumber: 'Numéro de série de l\'équipement',
    stcPlannerGroup: 'Groupe de planificateurs STC',
    selectstcPlannerGroup: 'Sélectionnez le groupe de planificateurs STC',
    CCplant: 'CC plant',
    selectCCplant: 'Sélectionner CC plant',
    distributor: 'Distributeur',
    selectDistributor: 'Sélectionnez un distributeur',
    failureAnalysisEngineerNotAssigned: 'Non affecté à l\'ingénieur d\'analyse des défaillances',
    openedJobs: 'Travaux ouverts',
    publishedJobs: 'Travaux publiés',
    unreadMessages: 'Messages non lus',
    pendingMyApproval: 'En attente de mon approbation',
    notificationNumber: 'Numéro de notification',
    serviceOrderNumber: 'Numéro de commande de service',
  },
  AddJob: { // Ajouter un travail
    formSections: { // Sections
      title: 'Ajouter un nouveau travail',
      createdAt: 'Date de création',
      button: 'Sauvegarder',
      basicInformation: { // Information
        title: 'Informations de base',
        fieldLabels: { // Étiquettes
          equipmentSerialNumber: 'Numéro de série de l\'équipement',
          serviceTechnologyCenter: 'Centre de technologie de service',
          customerCenter: 'Customer center',
          reportLevel: 'Niveau de rapport',
          initialWarrantyCode: 'Garantie initiale',
          customerPurchaseOrderNumber: 'Numéro de bon de commande du client',
          responsibleSalesPerson: 'Vendeur responsable',
          customerCenterContactName: 'Nom du contact du centre client',
          customerCenterContactEmail: 'Adresse e-mail de contact du centre client',
        },
      },
      jobType: { // Type
        title: 'Type',
        fieldLabels: { // Étiquettes
          jobType: 'Type',
          jobTypeDescription: 'La description',
        },
      },
      searchMaterialNumber: 'Rechercher le numéro d´article',
      materialNumber: {
        title: 'Numéro d\'article',
        fieldLabels: {
          materialNumber: 'Numéro d\'article',
          materialNumberDescription: 'La description',
        },
      },
      serviceProductNumber: {
        title: 'Numéro de produit de service',
        fieldLabels: {
          serviceProductNumber: 'Numéro de produit de service',
          serviceProductNumberDescription: 'La description',
        },
      },
      symptomCode: {
        title: 'Code de symptôme',
        fieldLabels: {
          scGroups: 'Groupe de codes de symptômes',
          symptomCode: 'Code de symptôme',
          symptomCodeDescription: 'La description',
        },
      },
      faultCode: {
        title: 'Code de défaut',
        fieldLabels: {
          fcGroups: 'Groupe de codes de défaut',
          faultCode: 'Code de défaut',
          faultCodeDescription: 'La description',
        },
      },
      customerInformation: { // Information
        title: 'Informations client',
        fieldLabels: {
          customerId: 'N ° de client',
          customerName: 'Nom',
          customerAddress: 'Adresse',
          customerContact: 'Contact',
          customerEmail: 'Adresse e-mail',
          customerPhone: 'Numéro de téléphone',
        },
      },
    },
  },
  ImportJob: { // Importer un travail
    title: 'Importer un travail',
    date: 'Date d\'importation',
    importButton: 'Importer',
    searchTitle: 'Rechercher un travail à importer',
    searchSubtitle: 'min 5 caractères, pas de zéros non significatifs',
    searchButton: 'Chercher',
    notificationNumberLabel: 'Numéro de notification',
    serviceOrderNumberLabel: 'Numéro de commande de service',
    linkTo: 'Lié à',
    openJobsFoundForSerNumber: 'Travails ouverts trouvés pour ce numéro de série',
    importJobAsNew: 'Importer le travail comme nouveau',
    jobIsImportedAlready: 'Le travail est déjà importé',
    importing: 'Importing in progress... FR',
    linking: 'Linking in progress... FR',
    columns: {
      sourceId: 'Identifiant de la source',
      notificationNumber: 'N ° de notification',
      serviceOrderNumber: 'Ordre de service Nr',
      serialNumber: 'Numéro de série',
      jobTypeDescription: 'La description',
      customerName: 'Nom du client',
    },
  },
  SingleJob: { // Travail unique
    title: 'Travail',
    createdAt: 'Créé à',
    modifiedAt: 'Dernière modification à',
    serviceOrderNumber: 'Numéro de commande de service',
    notificationNumber: 'Numéro de notification',
    receivedProduct: 'Produit reçu',
    productEvaluation: 'Évaluation du produit',
    stripObservation: 'Strip observation',
    technicalInvestigation: 'Investigation technique',
    conformityTest: 'Test de conformité',
    log: 'Log',
    conversation: 'Conversation',
    noTechPossibilityParagraph1: 'Ce STC n\'a pas de capacité de test pour ce travail.',
    noTechPossibilityParagraph2: 'Veuillez fermer le travail et envoyer la pompe à un autre STC.',
    downloadPictures: 'Télécharger des photos',
    downloadAllPictures: 'Téléchargez toutes les photos',
    downloadPicturesFrom: 'Télécharger des photos de',
    downloadInProgressPleaseWait: 'Download in progress... Please wait FR',
  },
  JobSummary: { // Résumé du travail
    title: 'Résumé du travail',
    createdAt: 'Créé à',
    modifiedAt: 'Dernière modification à',
    reportLevelDialogTitle: 'Niveau de rapport',
    reportLevelDialogContent: 'Définir le niveau de rapport demandé',
    reportLevelDialogInitialWarrantyCodeLabel: 'Garantie initiale code',
    approveReportLevelDialogTitle: 'Approuver la demande de niveau de rapport',
    technicalWarrantyDialogTitle: 'Proposer une décision technique',
    editTechnicalWarrantyDialogTitle: 'Edit technical decision proposal',
    rateTechnicalDecisionTitle: 'Évaluer la décision technique',
    rate: 'Rate',
    reclassify: 'Reclassify',
    technicalWarrantyDialogContent: 'Décision de garantie',
    technicalWarrantyDialogCategory: 'Catégorie de garantie',
    technicalWarrantyDialogSIBFieldLabel: 'SIB',
    approveTechnicalWarrantyDialogTitle: 'Approuver la proposition de garantie technique',
    approveTechnicalWarrantyDialogSIBLabel: 'SIB',
    reclassifyTechnicalWarrantyDialogTitle: 'Reclasser la catégorie de décision technique',
    commercialDecisionDialogTitle: 'Make commercial decision FR',
    commercialDecisionDialogContent: 'Décision commerciale',
    commercialDecisionDialogCategory: 'Commercial category FR',
    approveCommercialDecisionDialogTitle: 'Approuver la proposition',
    amendTechnicalWarrantyDecisionDialogTitle: 'Amend technical warranty decision FR',
    amendCommercialDecisionDialogTitle: 'Amend commercial decision FR',
    editPriceDialogTitle: 'Modifier le prix',
    editPriceLabel: 'Modifier',
    proposedDate: 'Date proposée',
    releaseJobDialogTitle: 'Lancer le travail',
    chooseReleaseJobMethodTitle: 'Choisissez la méthode de travail de lancement',
    editChosenReleaseJobMethodTitle: 'Modifier la méthode de lancement du travail choisie',
    releaseJobDialogLabel: 'Sélectionnez la méthode',
    reportStatusDialogTitle: 'Proposer l\'état du rapport',
    reportStatusDialogContent: 'Cela va créer une demande d\'approbation du rapport.',
    approveReportStatusDialogContent: 'Êtes-vous sûr de vouloir rouvrir ce poste?',
    approveReportStatusDialogTitle: 'Report approval request FR',
    editJobStatusDialogTitle: 'Modifier le statut du travail',
    editEquipmentSerialNumberDialogTitle: 'Modifier le numéro de série de l\'équipement',
    editEquipmentSerialNumberDialogFieldLabel: 'Numéro de série de l\'équipement',
    editMaterialNumberDialogTitle: 'Modifier le numéro d\'article',
    editMaterialNumberDialogFieldLabel: 'Numéro d\'article',
    editMaterialNumberDialogDescriptionFieldLabel: 'La description',
    warrantyStartDialogTitle: 'Modifier la date de début de la garantie',
    warrantyStartDateLabel: '	Date de début de la garantie',
    warrantyEndDialogTitle: 'Modifier la date de fin de garantie',
    warrantyEndDateLabel: 'Date de fin de garantie',
    verifyJobDialogTitle: 'Vérifier le travail',
    verifyJobDialogContent: 'Cette action va bloquer les numéros de matériel et d\'équipement pour l\'édition. Etes-vous sûr que les données suivantes sont correctes?',
    materialNumber: 'Numéro d\'article',
    equipmentSerialNumber: 'Numéro de série de l\'équipement',
    deleteConfirmationDialogTitle: 'Confirmation nécessaire',
    deleteConfirmationDialogContent: 'Êtes-vous sûr de vouloir supprimer ce travail?',
    teamDialogTitle: 'Ajouter un membre de l\'équipe',
    removeTeamMemberDialogTitle: 'Supprimer un membre de l\'équipe',
    removeTeamMemberDialogContent: 'Êtes-vous sûr de vouloir supprimer ce membre de l\'équipe?',
    technicalDecisionReason: 'Raison de la décision technique',
    warrantyExpiredSubcategoryLabel: 'Out of standard warranty period - Warranty subcategory',
    changeReportLevelReason: 'Raison du changement de niveau de rapport',
    rateTechnicalDecisionComment: 'Commentaire sur l´évaluation de la décision technique',
    decisionReason: 'Raison de la décision',
    commercialDecisionReason: 'Raison de la décision commerciale',
    approveReportLevelDialogRequestedLevel: 'Niveau demandé',
    approveReportLevelDialogPreviousLevel: 'Niveau précédent',
    approveReportLevelDialogInitialWarrantyCode: 'Garantie initiale code',
    initialWarrantyCode: 'Garantie initiale code',
    shipToAddress: 'Envoyer à l\'adresse',
    partNumbers: 'Références',
    failureReason: 'Raison de l\'échec',
    symptomReason: 'Raison du symptôme',
    chooseMethod: 'Choisissez la méthode',
    chosenMethod: 'Méthode choisie',
    serialNumberMissingPleaseAdd: 'Numéro de série manquant, veuillez l´ajouter.',
    deleteImportedJob: 'Delete imported',
    deleteImportedJobConfirmationDialogContent: 'Are you sure that you want to fully delete this imported job?',
  },
  LogSection: { // Section du log
    title: 'Log',
    sib: 'SIB',
    initialWarrantyCode: 'Garantie initiale code',
  },
  ReportsDialog: { // Dialog de rapports
    title: 'Générer un rapport',
    confirmButton: 'Générer',
    reportFormat: 'Format de rapport',
    reportTemplate: 'Modèle de rapport',
  },
  ActionMode: { // Mode d´action
    takePicture: 'Prendre une photo',
    takeStandardPicture: 'Prendre une photo standard',
    takeNonStandardPicture: 'Prendre une photo non standard',
    lastScreenMessage: 'Vous avez atteint la fin de cette section. Veuillez fermer cette fenêtre.',
    lastScreenMessageUnsavedAnswers: 'Vous avez atteint la fin de cette section. Veuillez sauvegarder vos réponses.'
  },
  InputFile: {
    special: 'Image non standard',
    upload: 'Télécharger',
    uploadStandardPicture: 'Télécharger une image standard',
    uploadNonStandardPicture: 'Télécharger une image non standard',
    commentPicture: 'Commenter la photo',
    confirmButtonText: 'Enregistrer le commentaire',
    moveFileModal: {
      title: 'Déplacer le fichier',
      confirmButtonText: 'Déplacer',
      selectSubsection: 'Sélectionnez la sous-section',
      selectQuestion: 'Sélectionnez une question',
    },
  },
  FilePreviewModal: {
    moveFileButtonText: 'Déplacer',
  },
}



// WEBPACK FOOTER //
// ./src/constants/translations/fr.js